import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PageViewContext = createContext<
  ((location: { pathname: string; search: string }) => void) | null
>(null);

/** Redirecting pages wait until their final destination is known. */
export function usePageView(ready = true) {
  const reportPageView = useContext(PageViewContext);
  const { pathname, search } = useLocation();
  if (!reportPageView) throw new Error("usePageView requires RouteTracker");

  useEffect(() => {
    if (ready) reportPageView({ pathname, search });
  }, [ready, reportPageView, pathname, search]);
}
